import React, { Component } from 'react'
import { Progress, Tooltip } from 'reactstrap'
import ModalInfo from './ModalInfo'

class StatusBar extends Component{
    constructor(props) {
        super(props);
        this.state = {
            title: null,
            color: null,
            progress: 0,
            message: null,
            tooltipInfo: false,
            showModal: false
        };
    }

    setStatus(status){
        switch(status) {
            case 0:
                this.setState({
                    title: "Enviado a laboratorio",
                    color: "status-0",
                    progress: 0
                })
                break
            case 1:
                this.setState({
                    title: "En estudio",
                    color: "status-0",
                    progress: 20
                })
                break
            case 2:
                this.setState({
                    title: "Esperando aprobación",
                    color: "status-1",
                    progress: 40
                })
                break
            case 3:
                this.setState({
                    title: "Aprobado",
                    color: "status-2",
                    progress: 60
                })
                break
            case 4:
                this.setState({
                    title: "Iniciada producción",
                    color: "status-3",
                    progress: 80
                })
                break
            case 5:
                this.setState({
                    title: "Entregado parcial",
                    color: "status-4",
                    progress: 90,
                    message: this.props.partialDelivery
                })
                break
            case 6:
                this.setState({
                    title: "Entregado",
                    color: "status-5",
                    progress: 100
                })
                break
            case 8:
                this.setState({
                    title: "No aceptado",
                    color: null,
                    progress: 0
                })
                break
            default:
                this.setState({
                    title: null,
                    color: null,
                    progress: 0
                })
        }
    }
    componentDidMount(){
        this.setStatus(Number(this.props.status))
    }
    componentWillReceiveProps(nextProps){
        this.setStatus(Number(nextProps.status))
    }
    componentWillUnmount(){
        this.setStatus()
    }
    toggleTooltipInfo() {
        this.setState({
            tooltipInfo: !this.state.tooltipInfo
        });
    }
    toggleModal() {
        this.setState({
            showModal: !this.state.showModal
        })
    }
    render(){
        const tooltipId = !this.props.casoId ? "tooltipInfo" : "tooltipInfo_"+this.props.casoId
        return(
            <div>
                <span className="text-muted">
                    {this.state.title} {this.state.message && Number(this.props.status) === 5 && <span>
                    <i id={tooltipId}
                       style={{cursor: 'pointer'}}
                       className="fa fa-info-circle text-info"
                       onClick={this.toggleModal.bind(this)}
                    ></i>
                    <Tooltip
                    placement="top"
                    isOpen={this.state.tooltipInfo}
                    target={tooltipId}
                    toggle={this.toggleTooltipInfo.bind(this)}
                >
                    Haz click para obtener más información sobre el estado de la entrega
                </Tooltip></span>
                }
                </span>
                <br />
                <Progress barClassName={this.state.color} style={{height: "2px"}} value={this.state.progress} />
                <ModalInfo
                    isOpen={this.state.showModal}
                    toggler={this.toggleModal.bind(this)}
                    title="Entrega parcial"
                    message={this.state.message}
                />
            </div>
        )
    }
}
export default StatusBar


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/StatusBar.jsx